function getPathFromDocsUrl(docsUrl: string): string {
  const raw = (docsUrl || '').trim();
  if (!raw) return '';
  let pathname: string;
  try {
    pathname = new URL(raw, 'http://localhost').pathname;
  } catch {
    pathname = raw;
  }
  return pathname.replace(/\/docs\/?$/, '').replace(/^\//, '').replace(/\/$/, '');
}

export function getOpenApiSpecUrl(docsUrl: string, apiBaseUrl: string): string {
  const path = getPathFromDocsUrl(docsUrl);
  if (!path || !apiBaseUrl) return '';
  const base = (apiBaseUrl || '').replace(/\/$/, '');
  return `${base}/${path}/openapi.json`;
}

export function getQuotaUrl(docsUrl: string, apiBaseUrl: string): string {
  const path = getPathFromDocsUrl(docsUrl);
  if (!path || !apiBaseUrl) return '';
  const base = (apiBaseUrl || '').replace(/\/$/, '');
  return `${base}/${path}/quota`;
}

/** Base URL for a service (e.g. `https://api/v1/boltz2`) — same path as OpenAPI without `/openapi.json`. */
export function getServiceBaseUrl(docsUrl: string, apiBaseUrl: string): string {
  const path = getPathFromDocsUrl(docsUrl);
  if (!path || !apiBaseUrl) return '';
  const base = (apiBaseUrl || '').replace(/\/$/, '');
  return `${base}/${path}`;
}

export function getEndpointSlug(docsUrl: string): string {
  const base = (docsUrl || '').replace(/\/docs\/?$/, '');
  if (!base) return '';
  try {
    const pathname = new URL(base).pathname;
    const segments = pathname.split('/').filter(Boolean);
    return segments[segments.length - 1] ?? '';
  } catch {
    return '';
  }
}
